import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MobileBottomNav from '../../components/feature/MobileBottomNav';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function OzelTasarim() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    occasion: '',
    figures: [] as string[],
    concept: '',
    photoCount: '1',
    name: '',
    phone: '',
    notes: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const occasions = [
    { id: 'dogum', name: 'Doğum Anısı', icon: 'ri-bear-smile-line' },
    { id: 'evlilik', name: 'Evlilik Anısı', icon: 'ri-heart-line' },
    { id: 'mezuniyet', name: 'Mezuniyet', icon: 'ri-graduation-cap-line' },
    { id: 'nisan', name: 'Nişan', icon: 'ri-gift-line' },
    { id: 'yildonumu', name: 'Yıldönümü', icon: 'ri-cake-line' },
    { id: 'diger', name: 'Diğer', icon: 'ri-star-line' }
  ];

  const figures = [
    { id: 'teddy', name: 'Ayıcık', icon: 'ri-bear-smile-line' },
    { id: 'balloon', name: 'Balon', icon: 'ri-bubble-chart-line' },
    { id: 'heart', name: 'Kalp', icon: 'ri-heart-line' },
    { id: 'flower', name: 'Çiçek', icon: 'ri-flower-line' },
    { id: 'star', name: 'Yıldız', icon: 'ri-star-line' },
    { id: 'cloud', name: 'Bulut', icon: 'ri-cloud-line' },
    { id: 'moon', name: 'Ay', icon: 'ri-moon-line' },
    { id: 'sun', name: 'Güneş', icon: 'ri-sun-line' }
  ];

  const concepts = [
    { id: 'deniz', name: 'Deniz Konsepti', icon: 'ri-ship-line' },
    { id: 'orman', name: 'Orman Konsepti', icon: 'ri-tree-line' },
    { id: 'hayvan', name: 'Hayvanlar Konsepti', icon: 'ri-bear-smile-line' },
    { id: 'uzay', name: 'Uzay Konsepti', icon: 'ri-rocket-line' },
    { id: 'prenses', name: 'Prenses Konsepti', icon: 'ri-vip-crown-line' },
    { id: 'vintage', name: 'Vintage Konsepti', icon: 'ri-camera-line' }
  ];

  const toggleFigure = (figureId: string) => {
    setFormData(prev => ({
      ...prev,
      figures: prev.figures.includes(figureId)
        ? prev.figures.filter(f => f !== figureId)
        : [...prev.figures, figureId]
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.occasion || formData.figures.length === 0 || !formData.concept || !formData.phone) {
      alert('Lütfen tüm zorunlu alanları doldurun!');
      return;
    }

    setIsSubmitting(true);

    const submitData = new URLSearchParams();
    submitData.append('occasion', formData.occasion);
    submitData.append('figures', formData.figures.join(', '));
    submitData.append('concept', formData.concept);
    submitData.append('photoCount', formData.photoCount);
    submitData.append('name', formData.name);
    submitData.append('phone', formData.phone);
    submitData.append('notes', formData.notes);

    try {
      const response = await fetch('https://readdy.ai/api/form/d6o0td539lnhn4hh1290', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: submitData.toString()
      });

      if (response.ok) {
        alert('Talebiniz başarıyla gönderildi! 24 saat içinde WhatsApp üzerinden size dönüş yapılacaktır.');
        setFormData({
          occasion: '',
          figures: [],
          concept: '',
          photoCount: '1',
          name: '',
          phone: '',
          notes: ''
        });
        setStep(1);
      } else {
        alert('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      alert('Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#faf9f7]">
      <Navbar />
      <WhatsAppButton />

      <div className="pt-24 pb-28 md:pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="text-orange-500 text-xs font-bold tracking-[0.3em] uppercase mb-2">Sınırsız Seçenek</p>
            <h1 className="text-4xl md:text-5xl font-black font-['Playfair_Display'] text-gray-900 mb-4">
              ÖZEL TASARIM TALEBİ
            </h1>
            <p className="text-sm text-gray-500">
              Hayalinizdeki tasarımı birlikte yaratalım
            </p>
          </div>

          {/* Progress Bar */}
          <div className="mb-12">
            <div className="flex items-center justify-between">
              {[1, 2, 3, 4].map((s) => (
                <div key={s} className="flex items-center flex-1">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all text-sm ${
                    step >= s 
                      ? 'bg-gray-900 text-white' 
                      : 'bg-gray-100 text-gray-400'
                  }`}>
                    {step > s ? <i className="ri-check-line"></i> : s}
                  </div>
                  {s < 4 && (
                    <div className={`flex-1 h-0.5 mx-2 transition-all ${
                      step > s ? 'bg-orange-500' : 'bg-gray-200'
                    }`}></div>
                  )}
                </div>
              ))}
            </div>
            <div className="flex justify-between mt-2 text-[10px] text-gray-500 font-bold uppercase tracking-wide">
              <span>Konsept</span>
              <span>Figürler</span>
              <span>Detaylar</span>
              <span>Teklif</span>
            </div>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} data-readdy-form className="bg-white rounded-2xl border border-gray-100 p-8 md:p-12">
            {/* Step 1: Occasion */}
            {step === 1 && (
              <div className="space-y-6">
                <h2 className="text-2xl font-black font-['Playfair_Display'] text-gray-900 mb-6">
                  Hangi özel gün için tasarım istiyorsunuz?
                </h2>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {occasions.map((occ) => (
                    <label
                      key={occ.id}
                      className={`relative p-5 border-2 rounded-xl cursor-pointer transition-all hover:border-orange-400 ${
                        formData.occasion === occ.id
                          ? 'border-orange-500 bg-orange-50'
                          : 'border-gray-100'
                      }`}
                    >
                      <input
                        type="radio"
                        name="occasion"
                        value={occ.id}
                        checked={formData.occasion === occ.id}
                        onChange={(e) => setFormData({ ...formData, occasion: e.target.value })}
                        className="sr-only"
                      />
                      <div className="text-center">
                        <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                          <i className={`${occ.icon} text-3xl ${formData.occasion === occ.id ? 'text-orange-500' : 'text-gray-300'}`}></i>
                        </div>
                        <p className="font-bold text-gray-900 text-sm">{occ.name}</p>
                      </div>
                      {formData.occasion === occ.id && (
                        <div className="absolute top-2 right-2 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center">
                          <i className="ri-check-line text-white text-xs"></i>
                        </div>
                      )}
                    </label>
                  ))}
                </div>
                <button
                  type="button"
                  onClick={() => formData.occasion && setStep(2)}
                  disabled={!formData.occasion}
                  className="w-full py-4 bg-gray-900 text-white font-bold rounded-lg hover:bg-gray-800 transition-all disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap text-sm tracking-wide"
                >
                  DEVAM ET
                </button>
              </div>
            )}

            {/* Step 2: Figures */}
            {step === 2 && (
              <div className="space-y-6">
                <h2 className="text-2xl font-black font-['Playfair_Display'] text-gray-900 mb-2">
                  Hangi figürleri kullanmak istersiniz?
                </h2>
                <p className="text-xs text-gray-400 font-medium">Birden fazla seçim yapabilirsiniz</p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {figures.map((fig) => (
                    <label
                      key={fig.id}
                      className={`relative p-5 border-2 rounded-xl cursor-pointer transition-all hover:border-orange-400 ${
                        formData.figures.includes(fig.id)
                          ? 'border-orange-500 bg-orange-50'
                          : 'border-gray-100'
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={formData.figures.includes(fig.id)}
                        onChange={() => toggleFigure(fig.id)}
                        className="sr-only"
                      />
                      <div className="text-center">
                        <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                          <i className={`${fig.icon} text-2xl ${formData.figures.includes(fig.id) ? 'text-orange-500' : 'text-gray-300'}`}></i>
                        </div>
                        <p className="font-bold text-gray-900 text-xs">{fig.name}</p>
                      </div>
                      {formData.figures.includes(fig.id) && (
                        <div className="absolute top-2 right-2 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center">
                          <i className="ri-check-line text-white text-xs"></i>
                        </div>
                      )}
                    </label>
                  ))}
                </div>
                <div className="flex gap-3">
                  <button type="button" onClick={() => setStep(1)} className="flex-1 py-4 bg-gray-100 text-gray-700 font-bold rounded-lg hover:bg-gray-200 transition-all whitespace-nowrap text-sm cursor-pointer">
                    GERİ
                  </button>
                  <button
                    type="button"
                    onClick={() => formData.figures.length > 0 && setStep(3)}
                    disabled={formData.figures.length === 0}
                    className="flex-1 py-4 bg-gray-900 text-white font-bold rounded-lg hover:bg-gray-800 transition-all disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap text-sm"
                  >
                    DEVAM ET
                  </button>
                </div>
              </div>
            )}

            {/* Step 3: Concept */}
            {step === 3 && (
              <div className="space-y-6">
                <h2 className="text-2xl font-black font-['Playfair_Display'] text-gray-900 mb-6">
                  Hangi konsepti tercih edersiniz?
                </h2>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  {concepts.map((con) => (
                    <label
                      key={con.id}
                      className={`relative p-5 border-2 rounded-xl cursor-pointer transition-all hover:border-orange-400 ${
                        formData.concept === con.id
                          ? 'border-orange-500 bg-orange-50'
                          : 'border-gray-100'
                      }`}
                    >
                      <input
                        type="radio"
                        name="concept"
                        value={con.id}
                        checked={formData.concept === con.id}
                        onChange={(e) => setFormData({ ...formData, concept: e.target.value })}
                        className="sr-only"
                      />
                      <div className="text-center">
                        <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                          <i className={`${con.icon} text-3xl ${formData.concept === con.id ? 'text-orange-500' : 'text-gray-300'}`}></i>
                        </div>
                        <p className="font-bold text-gray-900 text-sm">{con.name}</p>
                      </div>
                      {formData.concept === con.id && (
                        <div className="absolute top-2 right-2 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center">
                          <i className="ri-check-line text-white text-xs"></i>
                        </div>
                      )}
                    </label>
                  ))}
                </div>
                
                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide mb-2">
                    Fotoğraf Bölümü Sayısı
                  </label>
                  <select
                    name="photoCount"
                    value={formData.photoCount}
                    onChange={(e) => setFormData({ ...formData, photoCount: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-300 bg-white"
                  >
                    <option value="1">1 Fotoğraf</option>
                    <option value="2">2 Fotoğraf</option>
                    <option value="3">3 Fotoğraf</option>
                    <option value="4">4 Fotoğraf</option>
                    <option value="5">5 Fotoğraf</option>
                  </select>
                </div>

                <div className="flex gap-3">
                  <button type="button" onClick={() => setStep(2)} className="flex-1 py-4 bg-gray-100 text-gray-700 font-bold rounded-lg hover:bg-gray-200 transition-all whitespace-nowrap text-sm cursor-pointer">
                    GERİ
                  </button>
                  <button
                    type="button"
                    onClick={() => formData.concept && setStep(4)}
                    disabled={!formData.concept}
                    className="flex-1 py-4 bg-gray-900 text-white font-bold rounded-lg hover:bg-gray-800 transition-all disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap text-sm"
                  >
                    DEVAM ET
                  </button>
                </div>
              </div>
            )}

            {/* Step 4: Contact Info */}
            {step === 4 && (
              <div className="space-y-5">
                <h2 className="text-2xl font-black font-['Playfair_Display'] text-gray-900 mb-6">
                  İletişim Bilgileriniz
                </h2>
                
                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide mb-2">Adınız Soyadınız</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-300"
                    placeholder="Adınız ve soyadınız"
                  />
                </div>

                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide mb-2">
                    WhatsApp Numaranız <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-300"
                    placeholder="05XX XXX XX XX"
                    required
                  />
                </div>

                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide mb-2">
                    Ek Notlar <span className="text-gray-400 font-normal normal-case">(isteğe bağlı)</span>
                  </label>
                  <textarea
                    name="notes"
                    value={formData.notes}
                    onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-300 resize-none"
                    placeholder="Tasarımla ilgili özel isteklerinizi buraya yazabilirsiniz..."
                  ></textarea>
                  <p className="text-xs text-gray-400 text-right mt-1">{formData.notes.length}/500</p>
                </div>

                <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 flex items-start gap-3">
                  <i className="ri-information-line text-orange-500 text-lg mt-0.5 shrink-0"></i>
                  <p className="text-sm text-orange-900">
                    <strong>Bilgilendirme:</strong> Teklifiniz 24 saat içinde WhatsApp numaranıza gönderilecektir.
                  </p>
                </div>

                <div className="flex gap-3">
                  <button type="button" onClick={() => setStep(3)} className="flex-1 py-4 bg-gray-100 text-gray-700 font-bold rounded-lg hover:bg-gray-200 transition-all whitespace-nowrap text-sm cursor-pointer">
                    GERİ
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting || !formData.phone}
                    className="flex-1 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-lg transition-all disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap text-sm"
                  >
                    {isSubmitting ? 'Gönderiliyor...' : 'TEKLİF İSTE'}
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>

      <Footer />
      <MobileBottomNav />
    </div>
  );
}